export default __webpack_public_path__ + "assets/images/c4ba60d980154e28abc987c0ff905f5f.jpg";